export default __webpack_public_path__ + "static/spahotel-699e369260a7e5364eca99de96260aa7.svg";